@if (product$ | async; as product) {
  <main class="public-product-page">
    <header class="public-header" aria-label="Shine product pages">
      <a class="brand-link" routerLink="/products/ai" aria-label="Shine products">
        <img src="/assets/images/logos/Shine%20logo.svg" alt="" />
        <span>Shine</span>
      </a>

      <nav class="product-nav" aria-label="Products">
        @for (item of products; track trackProduct($index, item)) {
          <a
            [class.active]="item.slug === product.slug"
            [routerLink]="['/products', item.slug]"
          >
            {{ item.name.replace('Shine ', '') }}
          </a>
        }
      </nav>
    </header>

    <section class="hero-section" [attr.data-product]="product.slug">
      <div class="hero-copy">
        <p class="eyebrow">{{ product.eyebrow }}</p>
        <h1>{{ product.name }}</h1>
        <p class="summary">{{ product.summary }}</p>
        <p class="audience">{{ product.audience }}</p>

        <div class="hero-actions">
          <a mat-flat-button color="primary" [routerLink]="product.primaryRoute">Open in Shine</a>
          <a mat-stroked-button href="#feature-value-table">View table</a>
        </div>
      </div>

      <aside class="product-visual" aria-label="Product summary">
        <div class="visual-topline">
          <img [src]="product.logoSrc" [alt]="product.name + ' logo'" />
          <span>{{ product.name }}</span>
        </div>

        <div class="visual-list">
          @for (group of product.featureGroups.slice(0, 3); track trackFeatureGroup($index, group)) {
            <div class="visual-row">
              <span class="visual-check" aria-hidden="true"></span>
              <div class="visual-copy">
                <strong>{{ group.title }}</strong>
                <span>{{ group.items[0] }}</span>
              </div>
            </div>
          }
        </div>

        <div class="visual-boundary">
          <strong>Primary route</strong>
          <span>{{ product.primaryRoute }}</span>
        </div>
      </aside>
    </section>

    <section class="content-band" id="feature-groups">
      <div class="section-heading">
        <p class="eyebrow">Feature groups</p>
        <h2>What {{ product.name }} covers</h2>
      </div>

      <div class="capability-grid">
        @for (group of product.featureGroups; track trackFeatureGroup($index, group)) {
          <article class="feature-card">
            <div class="feature-card__header">
              <i-tabler name="sparkles" class="icon-22"></i-tabler>
              <h3>{{ group.title }}</h3>
            </div>

            <ul>
              @for (item of group.items; track trackValue($index, item)) {
                <li>{{ item }}</li>
              }
            </ul>
          </article>
        }
      </div>
    </section>

    <section class="content-band feature-table-band" id="feature-value-table">
      <div class="section-heading">
        <p class="eyebrow">Feature value table</p>
        <h2>How teams get value</h2>
      </div>

      <div class="feature-table-wrap">
        <table class="feature-value-table">
          <thead>
            <tr>
              @for (column of featureTableColumns; track column) {
                <th scope="col">{{ column }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of product.featureValueRows; track trackFeatureValueRow($index, row)) {
              <tr>
                <td [attr.data-label]="featureTableColumns[0]"><strong>{{ row.feature }}</strong></td>
                <td [attr.data-label]="featureTableColumns[1]">{{ row.whatItDoes }}</td>
                <td [attr.data-label]="featureTableColumns[2]">{{ row.whyItsValuable }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="split-section">
      <div>
        <div class="section-heading">
          <p class="eyebrow">Workflow</p>
          <h2>How teams use it</h2>
        </div>

        <ol class="workflow-list">
          @for (step of product.workflows; track trackValue($index, step)) {
            <li>
              <span>{{ $index + 1 }}</span>
              <p>{{ step }}</p>
            </li>
          }
        </ol>
      </div>

      <div class="detail-panels">
        <section class="detail-panel">
          <h3>Configuration and admin surfaces</h3>
          <ul>
            @for (surface of product.configSurfaces; track trackValue($index, surface)) {
              <li>{{ surface }}</li>
            }
          </ul>
        </section>

        <section class="detail-panel">
          <h3>Integrations and data boundaries</h3>
          <ul>
            @for (integration of product.integrations; track trackValue($index, integration)) {
              <li>{{ integration }}</li>
            }
          </ul>
        </section>
      </div>
    </section>

    <section class="split-section split-section--tight">
      <section class="detail-panel">
        <h3>Constraints and readiness</h3>
        <ul>
          @for (constraint of product.constraints; track trackValue($index, constraint)) {
            <li>{{ constraint }}</li>
          }
        </ul>
      </section>

      @if (product.exclusions.length) {
        <section class="detail-panel">
          <h3>Not publicly claimed</h3>
          <div class="exclusion-list">
            @for (exclusion of product.exclusions; track trackExclusion($index, exclusion)) {
              <article class="exclusion-item">
                <div class="exclusion-item__header">
                  <span class="exclusion-pill exclusion-pill--{{ exclusion.status }}">{{ exclusion.status }}</span>
                  <strong>{{ exclusion.label }}</strong>
                </div>
                <p>{{ exclusion.reason }}</p>
              </article>
            }
          </div>
        </section>
      }
    </section>
  </main>
}
